import React, { FC, FunctionComponent, SVGProps, useState } from 'react'
import styles from './ProductItem.module.scss'
import Image from '../../../../../../../components/ui/_image/Image'
import { IProductItem } from '../interfaces/IProductItem'
import { ChevronRight } from '@material-ui/icons';
import { Icon } from '@material-ui/core';
import { ICurrency } from 'models/local/ILocalConfig';
import { ReactComponent as Organic } from "assets/icons/organic-icon.svg";
import { ReactComponent as SugarFree } from "assets/icons/sugar-free-icon.svg";
import { ReactComponent as GlutenFree } from "assets/icons/gluten-free-icon.svg";
import { ReactComponent as LactoseFree } from "assets/icons/lactose-free-icon.svg";
import { ReactComponent as Vegan } from "assets/icons/vegan-icon.svg";
import { ReactComponent as Vegetarian } from "assets/icons/vegetarian-icon.svg";
import useI18n from 'utils/i18n/hooks/useI18n';

export interface IProductItemProps {
    product: IProductItem,
    onClick: () => void,
    prefixPrice?: string
}

const ProductItem: FC<IProductItemProps> = ({ product, onClick }) => {
    const { currentLanguage} = useI18n();

    const [hasImageError, setHasImageError] = useState(false);

    const productNameLocalized = product.translations?.find(translation => translation.lang === currentLanguage)?.name ?? product.name;
    const productDescriptionLocalized = product.translations?.find(translation => translation.lang === currentLanguage)?.productInformation ?? product.description;

    const currency = JSON.parse(localStorage.getItem(`@currency`) || '{}') as ICurrency;

    const foodCategoryIcons: Record<string, FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined; }>> = {
        "Orgânico": Organic,
        "Sem açúcar": SugarFree,
        "Sem glúten": GlutenFree,
        "Sem lactose": LactoseFree,
        Vegano: Vegan,
        Vegetariano: Vegetarian,
    };

    const categoriesWithIcons = product.foodCategories?.map((category) => ({
        ...category,
        icon: foodCategoryIcons[category.name] ?? undefined,
    }));

    return (
        <div onClick={onClick} id={styles.ProductItem}>
            <div className={styles.container}>
                <div className={styles.image}>
                    {
                        !hasImageError ?
                        <Image src={product.thumbnailUrl} className={styles.img} onError={() => setHasImageError(true)} /> :
                        <div className={styles.imageFallback}>
                            <Icon className={styles.icon}>no_photography</Icon>
                        </div>
                    }
                </div>

                <div className={styles.content}>
                    <div className={styles.containerCard}>
                        <div className={styles.name}>
                            <h3>{productNameLocalized}</h3>
                        </div>
                        <div className={styles.description}>
                            <h3>{productDescriptionLocalized}</h3>
                        </div>
                        <div className={styles.mobilePrice}>
                            <span>{currency?.symbol ?? "R$"} </span>
                            <h3>
                                {product.price.toFixed(2).replace(".", ",")}
                            </h3>
                        </div>
                    </div>
                </div>

                {categoriesWithIcons?.length ? (
                    <div className={styles.foodCategories}>
                        {categoriesWithIcons?.map((category) => (
                            <category.icon key={category.id} className={styles.icon}  style={{ width: "16px", height: "16px" }}/>
                        ))}
                    </div>
                ) : null}

                <div className={styles.price}>
                    <span>{currency?.symbol ?? "R$"} </span>
                    <h3>
                        {product.price.toFixed(2).replace(".", ",")}
                    </h3>
                </div>

                <ChevronRight style={{ color: '#A2A2A2', fontSize: 22 }} />
            </div>
        </div>
    )
}
export default ProductItem